module.exports = __webpack_public_path__ + "img/cases_bjdx.6e15de89.jpg";